import React from 'react';

const CheckCircle:

React.FC<IconProps> = ({
    height,
    width,
    fillColor,
}) => {
    const h = height ?? 16;
    const w = width ?? 16;
    const fill = fillColor ?? "#454648";
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={w}
            height={h}
            viewBox="0 0 16 16"
            fill="none"
        >
            <path fillRule="evenodd" clipRule="evenodd" d="M8 0.666656C3.94991 0.666656 0.666668 3.9499 0.666668 7.99999C0.666668 12.0501 3.94991 15.3333 8 15.3333C12.0501 15.3333 15.3333 12.0501 15.3333 7.99999C15.3333 3.9499 12.0501 0.666656 8 0.666656ZM11.4714 6.47139C11.7318 6.21105 11.7318 5.78893 11.4714 5.52859C11.2111 5.26824 10.7889 5.26824 10.5286 5.52859L7 9.05718L5.47141 7.52859C5.21106 7.26824 4.78895 7.26824 4.5286 7.52859C4.26825 7.78893 4.26825 8.21105 4.5286 8.4714L6.5286 10.4714C6.78895 10.7317 7.21106 10.7317 7.47141 10.4714L11.4714 6.47139Z" fill={fill}/>
        </svg>
    );
};

export default CheckCircle;